import { useCallback } from 'react';

/**
 * Web rack drill-in: breadcrumb is on {@link RackEditChrome} ("All Racks").
 * Keeps callback wiring for parent step shells without duplicating back on H1.
 */
export function useWebRackEditorStepBack() {
  const onWebEditorActiveChange = useCallback(
    (_active: boolean, _onBack: () => void) => {
      /* breadcrumb handles back */
    },
    [],
  );

  return { titleLeading: null, onWebEditorActiveChange };
};
